import { resource, RequestConfig } from '../helper/resource';

/**
 * 查询协议列表
 */
export function sdCenterAgreeInfoUsingPOST(
  req: CaInfoParamDto | void,
  config?: RequestConfig
): Promise<ApiResultCaAgreeInfoVo> {
  return resource.post('/HKFundSign/sdCenterAgreeInfo', req, config);
}

/**
 * 查询协议内容
 */
export function sdCenterContentUsingPOST(
  req: CaContentParamDto | void,
  config?: RequestConfig
): Promise<ApiResultCaAgreementContent> {
  return resource.post('/HKFundSign/sdCenterContent', req, config);
}

/**
 * 批量签署协议
 */
export function sdCenterSignUsingPOST(req: SDSignDto | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/HKFundSign/sdCenterSign', req, config);
}
